import React from 'react';
import * as Styles from './NameStep.styles';
import { Button, IconArrow, TextField } from 'gatorcomponents';

const NameStep = ({
  nameStepLocales, continueButtonClick, nameInputValue, setNameInputValue, mobile, iconMaia,
}) => {
  const onChangeInput = (e) => {
    setNameInputValue(e.target.value);
  };

  const handleContinueButtonClick = () => {
    continueButtonClick && continueButtonClick();
  };

  return (
    <Styles.Wrapper data-testid="ai-builder-create-site-name-step">
      <Styles.Title>
        <Styles.IconMaia src={iconMaia} />
        {nameStepLocales.title}
      </Styles.Title>

      <Styles.InputHeadText>{nameStepLocales.inputHeadText}</Styles.InputHeadText>

      <TextField
        label={nameStepLocales.inputPlaceholder}
        onChange={onChangeInput}
        value={nameInputValue}
        maxLength={60}
        testId="name-step-name-field"
      />

      <Styles.ButtonWrapper>
        <Button
          testId="name-step-continue-button"
          label={nameStepLocales.buttonLabel}
          width={mobile ? 'full' : 'fit'}
          size="large"
          onClick={handleContinueButtonClick}
          disabled={!nameInputValue}
          iconRight={
            <IconArrow direction="right" />
          }
        />
      </Styles.ButtonWrapper>
    </Styles.Wrapper>
  );
};

export default NameStep;
